import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/Help';

const iconStyle = { width: 20, position: 'absolute', right: 3, top: 8, cursor: 'pointer' };
const containerStyle = { position: 'relative' };
const tooltipStyle = { fontSize: 14 };

const WithTooltip = ({ children, tooltipText }) => (
  <div style={containerStyle}>
    {children}
    <Tooltip title={<span style={tooltipStyle}>{tooltipText}</span>}>
      <HelpIcon style={iconStyle} />
    </Tooltip>
  </div>
);

export default WithTooltip;
